import { IntlShape } from 'react-intl';

/**
 * Builds a tool button tooltip. When `disabledReason` is provided it is
 * appended as a suffix — e.g. "Margin — Structure set is approved" — so the
 * user understands why a disabled tool is unavailable. Returns the plain tool
 * name when there is no reason.
 */
export function buildToolTooltip(
    intl: IntlShape,
    toolName: string,
    disabledReason?: string
): string {
    return disabledReason
        ? intl.formatMessage(
              { id: 'tool.disabledTooltip' },
              { toolName, reason: disabledReason }
          )
        : toolName;
}
